<template>
  <div class="creditIndex" :data="dataCredit">
    <!-- 当月的收入 -->
    <div class="flex_between">
      <h3 class="font_24_reg">{{$t('payList.total')}}: {{balance.balance_valid}}</h3>
      <el-button type="primary" @click="toRecharge">{{$t('index.topUp')}}</el-button>
    </div>
    <div class="flex_start searchForm">
      <div class="select-part">
        <el-date-picker
          v-model="ruleForm.timeRang"
          type="daterange"
          :range-separator="$t('payList.dash')"
          align="left"
          value-format="yyyy-MM-dd"
          :start-placeholder="$t('payList.date')"
          :end-placeholder="$t('payList.range')"
          @change="search">
        </el-date-picker>
      </div>
      <div class="select-part">
        <!-- <el-dropdown :hide-on-click="false">
          <span class="el-dropdown-link">
            Select Transaction Type<img src="../../assets/chevron-down.svg" />
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="item in creditData"
              :key="item.id"
              :label="item.title"
              :value="item.id"
              @change="search(item)">{{item.title}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
        <el-select v-model="ruleForm.transation" @change="search" filterable collapse-tags placeholder="Select Transaction Type">
            <!-- <el-option value="">{{$t('searchTabBar.all')}}</el-option> -->
            <el-option v-for="item in creditData"
              :key="item.id"
              :label="item.title"
              :value="item.id">
                <img :src="item.id=='register'?icon_1:(item.id=='monthScreenshot'?icon_2:icon_3)" />{{item.title}}
            </el-option>
        </el-select>
      </div>
      <div class="select-part">
        <el-select v-model="ruleForm.creditVal" @change="search" filterable collapse-tags placeholder="Credit Value + / –">
            <el-option v-for="item in creditValue"
              :key="item.id"
              :label="item.title"
              :value="item.id"
              >{{item.title}}</el-option>
        </el-select>
      </div>
      <a class="clearBtn font_18_bold" @click="resetFilter()">{{$t('payList.reset')}}</a>
    </div>
    <!-- 当月的教学数据 -->

    <!-- 每月的收入 -->
      <el-table
      :data="recordData"
      :empty-text="$t('global.noData')"
      class="creditBody"
      style="width: 100%;">
      <el-table-column
        prop="created_at"
        :label="$t('payList.dateTitle')"
        width="230px">
      </el-table-column>
      <el-table-column
        prop="title"
        :label="$t('payList.description')">
      <template slot-scope="scope">
        <div class="flex_start">
          <img :src="scope.row.event=='register'?icon_1:(scope.row.event=='monthScreenshot'?icon_2:icon_3)" />
          <h3>{{scope.row.title}}</h3>
        </div>
        <p class="flex_start">{{scope.row.message}}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="quantity"
        :label="$t('payList.credits')"
        width="230px">
      <template slot-scope="scope">{{scope.row.quantity}}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="pagenum"
      :page-size="pagesize"
      layout="prev, pager, next"
      :total="total">
    </el-pagination>
  </div>
</template>
<script>
import { setStore, getStore, keys } from '@/store';
export default {
  props: {
    dataCredit: Object,
    required: true
  },
  data () {
    return {
      creditData: [],
      recordData: [],
      total: 0,
      pagenum: 1, // 当前页码
      pagesize: 10, // 每页显示条数
      icon_1: require('@/assets/Badge_1.svg'), // 图片地址
      icon_2: require('@/assets/Badge_2.svg'), // 图片地址
      icon_3: require('@/assets/Badge_3.svg'), // 图片地址
      creditValue: [{
        id: '',
        title: this.$t('searchTabBar.all')
      }, {
        id: 'add',
        title: '+'
      }, {
        id: 'min',
        title: '-'
      }],
      ruleForm: {
        timeRang: Array.apply(null, Array(2)).map(() => ''),
        transation: '',
        creditVal: ''
      },
      balance: {}
    }
  },
  created () {
    this.balance = getStore(keys.userBalance)
    this.getData()
    this.recordData = this.dataCredit.data
    this.total = this.dataCredit.total
    this.search()
  },
  methods: {
    toRecharge () {
      this.$router.push({ path: '/recharge?type=credit' })
    },
    getData () {
      this.$http.post('/api/reward-setting').then((res) => {
        if (res.data.code == 200) {
          this.creditData = res.data.data
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    handleCurrentChange (val) {
      this.pagenum = val
      this.search()
    },
    resetFilter () {
      this.ruleForm = {
        timeRang: Array.apply(null, Array(2)).map(() => ''),
        transation: '',
        creditVal: ''
      }
      this.search()
    },
    search () {
      if (!this.ruleForm.timeRang) {
        this.ruleForm.timeRang = Array.apply(null, Array(2)).map(() => '')
      }
      this.$http.get('/api/account-logs/creditPC?type=' +
       this.ruleForm.transation + '&credit_value=' + this.ruleForm.creditVal +
       '&start_at=' + this.ruleForm.timeRang[0] + '&end_at=' + this.ruleForm.timeRang[1] +
       '&time_diff=' + this.utils.timeZone() + '&pagesize=' + this.pagesize +
       '&page=' + this.pagenum).then((res) => {
        if (res.data.code == 200) {
          this.recordData = res.data.data
          this.total = res.data.total
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .creditIndex{
    button{
      width: 160px;
      height: 40px;
      background: #ff6440;
      border-radius: 4px;
      border: 1px solid #ff6440;
      color: #fff;
      font-size: 16px;
      font-family: Sofia Pro-Bold;
      box-shadow: 0px 1px 6px 1px rgba(81,124,255,0.20), 0px 1px 6px 1px rgba(81,124,255,0.20);
    }
    .searchForm{
      display: flex;
      align-items: center;
      margin:20px 0;
    }
    ::-webkit-input-placeholder { /* WebKit browsers */
      color: #6B6B6B!important;
      font-size: 14px;
      font-family: Sofia Pro-Regular;
    }

    :-moz-placeholder { /* Mozilla Firefox 19+ */
      color: #6B6B6B!important;
      font-size: 14px;
      font-family: Sofia Pro-Regular;
    }

    ::-moz-placeholder { /* Mozilla Firefox 19+ */
      color: #6B6B6B!important;
      font-size: 14px;
      font-family: Sofia Pro-Regular;
    }

    :-ms-input-placeholder { /* Internet Explorer 10+ */
      color: #6B6B6B!important;
      font-size: 14px;
      font-family: Sofia Pro-Regular;
    }
    .select-part{
      margin-right: 20px;
      // .el-dropdown{
      //   width: 270px;
      //   height: 39px;
      //   line-height: 39px;
      //   background: none;
      //   border-bottom: 1px solid #A5A5A5;
      //   .el-dropdown-link{
      //     width: 270px;
      //     display: flex;
      //     justify-content: space-between;
      //   }
      // }
      .el-select {
        width: auto;
        height: 39px;
        background: none;
        border-bottom: 1px solid #A5A5A5;
        color: #353643;
        /deep/ .el-input{
          height:40px;
          .el-input__inner{
            width:330px;
            height: 100%;
            background: none;
            border:none;
            color: #353643;
            font-family: Sofia Pro-Regular;
          }
          .el-input__suffix{
            right: 15px;
          }
          .el-select__caret{
            color: #6e6b7b;
          }
        }
      }
    }
    .clearBtn{
      margin-left:40px;
      color:#ff6440;
      text-decoration: underline;
    }

      // 日历
      /deep/ .el-date-editor--daterange{
        width:230px;
        height:40px;
        border:none;
        border-bottom: 1px solid #a5a5a5;
        border-radius: 0;
        input,span{
          line-height: 35px;
        }
        input{
          width: 45%;
          text-align: left;
        }
        .el-range-separator{
          color:#979797;
          font-size: 14px;
          font-family: Sofia Pro-Regular;
        }
        .el-icon-date{
          display: none;
        }

      }
      /deep/ .el-table__body tr,.el-table__body tr td{
        img{
          width:18px;
          height:18px;
          margin-right:10px;
        }
      }

  }
</style>



// WEBPACK FOOTER //
// src/components/views/credit.vue